import { useEffect, useState } from 'react';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import _ from 'lodash';

const STORAGE_METHODS = {
  LOCAL: 'local',
  SESSION: 'session'
};

const useStorageConfiguration = ({
  storageKey,
  storageMethod = STORAGE_METHODS.LOCAL,
  defaultConfig
}) => {
  if (!_.values(STORAGE_METHODS).includes(storageMethod))
    throw new Error('useStorageConfiguration: storageMethod is illegal');

  const [storageConfig, setStorageConfig] = useState(null);

  const getConfig = () => {
    const config = BrowserStorageAccessor()[storageMethod].get(storageKey);
    if (!config) return null;

    return JSON.parse(config);
  };

  const createConfig = () => {
    BrowserStorageAccessor()[storageMethod].set(
      storageKey,
      JSON.stringify(defaultConfig)
    );
    setStorageConfig(defaultConfig);
  };

  const updateConfig = newConfig => {
    BrowserStorageAccessor()[storageMethod].set(
      storageKey,
      JSON.stringify(newConfig)
    );
    setStorageConfig(newConfig);
  };

  const removeConfig = () => {
    BrowserStorageAccessor()[storageMethod].remove(storageKey);
    setStorageConfig(null);
  };

  const initConfig = () => {
    const config = getConfig();
    if (!config) return createConfig();

    setStorageConfig(config);
  };

  useEffect(() => {
    initConfig();
  }, []);

  return {
    value: storageConfig,
    updateConfig,
    removeConfig
  };
};

export default useStorageConfiguration;
